import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Template from "./customer-details.html";
import Controller from "./customer-details.controller";
import CustomerDetailsModal from "./customer-details.modal";

let CustomerDetailsModule = Angular.module('customer-details', []);

CustomerDetailsModule.component('customer-details', [])
    .component('customerDetails', {
        template: Template,
        controller: Controller,
        bindings: {
            customer: '<',
            editable: '<',
            withContactDivider: '<',
            withAddressDivider: '<'
        }
    });

new Loader(CustomerDetailsModule)
    .load(CustomerDetailsModal);

export default CustomerDetailsModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/customer-details/customer-details.js